import { useNavigate } from 'react-router'
import { GoChevronLeft } from 'react-icons/go'

const Deactivate: React.FC = () => {
  const navigate = useNavigate()

  return (
    <div className="flex h-full w-full flex-col text-sm">
      <div className="flex h-[50px] items-center pl-[10px] text-xl font-semibold">
        <div className="flex items-center">
          <button
            type="button"
            className="hover-main mr-[10px] flex h-[30px] w-[30px] items-center justify-center rounded-full"
            onClick={() => {
              navigate('../account')
            }}
          >
            <GoChevronLeft />
          </button>
          <h1>Deactivate your account</h1>
        </div>
      </div>
      <div className="text-sub pt-[15px] pb-[25px] pl-[25px]">
        Account deactivation, deletion - isn't implemented yet.
      </div>
    </div>
  )
}

export default Deactivate
